import { Component, createRef, KeyboardEvent } from "react";
import Styles from "./ChatBar.module.css";

interface ChatBarProps
{
    placeholder?: string;
    disabled?: boolean;
    onSubmit: (message: string) => boolean | void;
}

interface ChatBarState
{
    value: string;
}

class ChatBar extends Component<ChatBarProps, ChatBarState>
{
    private textareaRef = createRef<HTMLTextAreaElement>();

    constructor(props: ChatBarProps)
    {
        super(props);
        this.state = { value: "" };
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    public clear()
    {
        this.setState({ value: "" });
        if (this.textareaRef.current)
            this.textareaRef.current.style.height = "auto";
    }

    private onChange(e: React.ChangeEvent<HTMLTextAreaElement>)
    {
        this.setState({ value: e.target.value });
        let el = this.textareaRef.current;
        if (el)
        {
            el.style.height = "auto";
            el.style.height = Math.min(el.scrollHeight, 192) + "px";
        }
    }

    private onKeyDown(e: KeyboardEvent<HTMLTextAreaElement>)
    {
        if (e.key === "Enter" && !e.shiftKey)
        {
            e.preventDefault();
            this.onSubmit();
        }
    }

    private onSubmit()
    {
        let text = this.state.value.trim();
        if (!text || this.props.disabled)
            return;
        if (this.props.onSubmit(text) === false)
            return;
        this.clear();
    }

    override render()
    {
        return (
            <div className={Styles.ns_chat_bar}>
                <div className={Styles.ns_chat_bar_wrapper}>
                    <textarea
                        ref={this.textareaRef}
                        className={Styles.ns_chat_bar_input}
                        placeholder={this.props.placeholder ?? "Ask anything..."}
                        value={this.state.value}
                        onChange={this.onChange}
                        onKeyDown={this.onKeyDown}
                        rows={1}
                    />
                    <button
                        type="button"
                        className={Styles.ns_chat_bar_submit}
                        onClick={this.onSubmit}
                        disabled={this.props.disabled || !this.state.value.trim()}
                    >
                        Send
                    </button>
                </div>
            </div>
        );
    }
}

export default ChatBar;